import { useContext, useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import { UserContext } from "../../../context/User.context";

import {
  Button,
  Col,
  Form,
  Popconfirm,
  Modal,
  Skeleton,
  Row,
  QRCode,
  Space,
  Select,
  Breadcrumb,
  Tag,
  Table,
  Input,
} from "antd";
import TextArea from "antd/es/input/TextArea";

import {
  ExportOutlined,
  ImportOutlined,
  InfoCircleTwoTone,
  HomeOutlined,
  PhoneOutlined,
  UsergroupAddOutlined,
  ApartmentOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  InfoCircleOutlined,
  CarOutlined,
  CheckCircleOutlined,
  BookOutlined,
  ClockCircleFilled,
  MergeCellsOutlined,
  HomeFilled,
  UserAddOutlined,
  InfoCircleFilled,
  CreditCardOutlined,
  CreditCardFilled,
  WhatsAppOutlined,
  BackwardOutlined,
  TruckFilled,
} from "@ant-design/icons";
import {
  formatDate,
  formatTimeDate,
  isDatePassed,
} from "../../../utils/DateTime";
import { useHttp } from "../../../utils/DataHendler";
import { debounce } from "lodash"; // Menggunakan lodash untuk debounce

export const DetailInstitutionVisit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { code } = useParams();
  const { getData, patchData } = useHttp();
  const { routeFrom } = location.state || {}; //untuk mengetahui params property yang diterima dari page lain

  // const { routeFrom } = location.state || {}; //untuk mengetahui params property yang diterima dari page lain

  const { user } = useContext(UserContext);
  const [form] = Form.useForm();

  const [detailData, setDetailData] = useState([]);
  const [dataCardVisitor, setCardVisitor] = useState([]);
  const [cardBackOpen, setcardBackOpen] = useState(false);
  const [cardAddOpen, setcardAddOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loadingCard, setLoadingCard] = useState(false);

  const [typeCard, setTypeCard] = useState({});

  useEffect(() => {
    getVisitor();
    // getCardVisitor();
  }, [user, code]);

  const getVisitor = async () => {
    setLoading(true);

    try {
      const response = await getData(`/institution/${code}`, {}, true);

      const data = response.data;

      setDetailData(data);
      getCardVisitor(null, data.visitor_type_name);
      setTypeCard({ type_card: data.visitor_type_name });

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getCardVisitor = async (search, type) => {
    setLoadingCard(true);
    // Membuat objek queryParams yang hanya berisi parameter yang ada nilai
    const queryParams = {};

    // console.log("INI TYPE VISITOR CARD :" + type);

    // Tambahkan department_id jika tersedia
    if (type) {
      queryParams.type = type;
    }

    // Tambahkan search jika tersedia
    if (search && search.trim() !== "") {
      queryParams.search = search.trim(); // Pastikan tidak ada spasi ekstra
    }

    try {
      const response = await getData(
        `/card/lookup`,
        { params: queryParams },
        true
      );

      const data = response.data.data;

      setCardVisitor(data);
      setLoadingCard(false);
    } catch (error) {
      console.log(error);
      setLoadingCard(false);
    }
  };

  const handleChange = (value) => {
    console.log(`selected ${value}`);
    // getCardVisitor(value, typeCard.type_card);
  };

  // Fungsi debounce untuk getData
  const debounceSearchCard = useCallback(
    debounce((value) => {
      console.log("Debounced search value:", value.search, value.type);
      getCardVisitor(value.search, value.type); // Panggil fungsi getData dengan nilai pencarian
      // form.resetFields();
    }, 1000), // Delay 500ms sebelum memanggil getData
    []
  );

  const onCardPicked = async (value, visitorId) => {
    setLoadingCard(true);

    try {
      await patchData(
        `/visitor/card`,
        {
          visitorId: visitorId,
          cardIds: value[`cardIds-${visitorId}`],
        },
        {},
        true
      );

      await getVisitor();
      form.resetFields();

      // productId = res.data.data.id;
      // console.log("BERHASIL MENAMBAHKAN KARTU");
      setLoadingCard(false);
      setcardAddOpen(false);
    } catch (error) {
      console.log(error);

      setLoading(false);
      setcardAddOpen(false);
    }
  };

  const showModalCardBack = () => {
    setcardBackOpen(true);
  };
  const showModalCardAdd = () => {
    setcardAddOpen(true);
  };

  const onCardReturn = async (value, visitorId) => {
    setLoading(true);

    // console.log({
    //   visitorId: visitorId,
    //   cardIds: value[`return-cardIds-${visitorId}`],
    // });
    form.resetFields();
    try {
      const res = await axios.patch(
        `https://cmi-general-platform-be.vercel.app/visitor/return-card`,
        {
          visitorId: visitorId,
          cardIds: value[`return-cardIds-${visitorId}`],
        },
        { headers: { Authorization: `Bearer ${user.token}` } }
      );

      // productId = res.data.data.id;

      console.log("BERHASIL MENAMBAHKAN /KARTU");
      setcardBackOpen(false);
      getVisitor();
    } catch (err) {
      console.log(err);

      setcardBackOpen(false);
      setLoading(false);
    }
  };

  //   const ModalAddCard = () => {
  //     return (
  //       <>
  //         <Modal
  //           title="Add Card"
  //           open={cardAddOpen}
  //           onOk={showModalCardAdd}
  //           onCancel={() => {
  //             setcardAddOpen(false);
  //           }}
  //           // okButtonProps={{ disabled: true }}
  //           // cancelButtonProps={{ disabled: true }}
  //           footer={null}
  //         >
  //           <Form
  //             form={form}
  //             layout="vertical"
  //             onFinish={(value) => {
  //               onCardPicked(value, detailData.id);
  //             }}
  //             autoComplete="off"
  //             style={{ textAlign: "left" }}
  //           >
  //             <Form.Item
  //               name={`cardIds-${detailData.id}`}
  //               rules={
  //                 [
  //                   //   {
  //                   //     required: true,
  //                   //   },
  //                 ]
  //               }
  //               label={
  //                 <div
  //                   style={{
  //                     fontWeight: "bold",
  //                     borderBottom: "2px solid #088395",
  //                     paddingBottom: "5px",
  //                     width: "fit-content",
  //                   }}
  //                 >
  //                   Kartu
  //                 </div>
  //               }
  //             >
  //               <Select
  //                 mode="multiple"
  //                 style={{ width: "100%" }}
  //                 placeholder="select one visitor"
  //                 disabled={loadingCard}
  //                 onChange={handleChange}
  //                 // onSearch={(val) => {
  //                 //   console.log(val);
  //                 // }}
  //                 filterOption={async (input, option) => {
  //                   // console.log("disini aja");
  //                   return await debounceSearchCard({
  //                     search: input,
  //                     type: detailData.visitor_type_name,
  //                   });
  //                 }}
  //                 options={dataCardVisitor.map((el) => ({
  //                   label: el.name,
  //                   value: el.id,
  //                   emoji: el.code,
  //                   desc: el.type,
  //                 }))}
  //                 optionRender={(option) => (
  //                   <Space>
  //                     <span role="img" aria-label={option.data.label}>
  //                       {option.data.emoji}
  //                     </span>
  //                     {option.data.desc}
  //                   </Space>
  //                 )}
  //               />
  //             </Form.Item>

  //             <Form.Item style={{ marginTop: "0px", textAlign: "left" }}>
  //               <Space size="middle">
  //                 <Button type="primary" htmlType="submit" loading={loadingCard}>
  //                   Add Card
  //                 </Button>
  //               </Space>
  //             </Form.Item>
  //           </Form>
  //         </Modal>
  //       </>
  //     );
  //   };

  //   ADD CARD VISITOR LIST
  const [addCardVisitListOpen, setaddCardVisitListOpen] = useState(false);
  const showcardVisitList = () => {
    setaddCardVisitListOpen(true);
  };
  const onCardVisitList = async (value, visitorId) => {
    setLoadingCard(true);

    try {
      await patchData(
        `/institution/card/process`,
        {
          institution_visitor_list_id: value.list_id,
          card_id: value.card_id,
          action: "pick",
        },
        {},
        true
      );

      await getVisitor();
      form.resetFields();

      // productId = res.data.data.id;
      // console.log("BERHASIL MENAMBAHKAN KARTU");
      setLoadingCard(false);
      setaddCardVisitListOpen(false);
    } catch (error) {
      console.log(error);

      setLoading(false);
      setaddCardVisitListOpen(false);
    }
  };
  const ModalAddCardVisitorList = () => {
    return (
      <>
        <Modal
          title="Add Card"
          open={addCardVisitListOpen}
          //   onOk={showcardVisitList}
          onCancel={() => {
            setaddCardVisitListOpen(false);
            form.resetFields();
          }}
          // okButtonProps={{ disabled: true }}
          // cancelButtonProps={{ disabled: true }}
          footer={null}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={(value) => {
              onCardVisitList(value, detailData.id);
            }}
            autoComplete="off"
            style={{ textAlign: "left" }}
          >
            <Form.Item name={`list_id`}></Form.Item>
            <Form.Item
              name={`card_id`}
              label={
                <div
                  style={{
                    fontWeight: "bold",
                    borderBottom: "2px solid #088395",
                    paddingBottom: "5px",
                    width: "fit-content",
                  }}
                >
                  Kartu
                </div>
              }
            >
              <Select
                showSearch
                style={{ width: "100%" }}
                placeholder="select one card"
                disabled={loadingCard}
                onChange={handleChange}
                onSearch={(input) =>
                  debounceSearchCard({
                    search: input,
                    type: detailData.visitor_type_name,
                  })
                }
                filterOption={() => true} // Filter dilakukan di onSearch
                options={dataCardVisitor.map((el) => ({
                  value: el.id,
                  label: (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span>{el.name}</span>
                      <span style={{ color: "#888" }}>{el.code}</span>
                    </div>
                  ),
                  code: el.code,
                  name: el.name,
                  type: el.type,
                }))}
                optionItemStyle={{ height: 40 }}
                optionItemClassName="custom-select-option"
              />
            </Form.Item>

            <Form.Item style={{ marginTop: "0px", textAlign: "left" }}>
              <Form.Item shouldUpdate>
                {() => {
                  const selected = form.getFieldValue("card_id");
                  return (
                    <Space size="middle">
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loadingCard}
                        disabled={
                          !selected ||
                          (Array.isArray(selected)
                            ? selected.length === 0
                            : !selected)
                        }
                      >
                        Add Card
                      </Button>
                    </Space>
                  );
                }}
              </Form.Item>
            </Form.Item>
          </Form>
        </Modal>
      </>
    );
  };

  // RETURN CARD PER VISITOR LIST

  const [returnCardVisitorListOpen, setReturnCardVisitorListOpen] =
    useState(false);
  const [returnVisitList, setreturnVisitList] = useState([]);
  const onReturnCardVisitList = async (value, visitorId, visitor_list_id) => {
    setLoading(true);

    try {
      await patchData(
        `/institution/card/process`,
        {
          institution_visitor_list_id: visitor_list_id,
          card_id: value.card_id,
          action: "return",
        },
        {},
        true
      );

      await getVisitor();
      form.resetFields();

      setLoading(false);
      setReturnCardVisitorListOpen(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setaddCardVisitListOpen(false);
    }
  };

  const ModalResturnCardPerVisitorList = () => {
    return (
      <>
        <Modal
          title="Return Card"
          open={returnCardVisitorListOpen}
          //   onOk={showcardVisitList}
          onCancel={() => {
            setReturnCardVisitorListOpen(false);
            form.resetFields();
          }}
          // okButtonProps={{ disabled: true }}
          // cancelButtonProps={{ disabled: true }}
          footer={null}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={(value) => {
              onReturnCardVisitList(
                value,
                detailData.id,
                returnVisitList[0].key
              );
            }}
            autoComplete="off"
            style={{ textAlign: "left" }}
          >
            <Form.Item name={`list_id`}></Form.Item>
            <Form.Item
              name={`card_id`}
              label={
                <div
                  style={{
                    fontWeight: "bold",
                    borderBottom: "2px solid #088395",
                    paddingBottom: "5px",
                    width: "fit-content",
                  }}
                >
                  Card
                </div>
              }
            >
              <Select
                showSearch
                style={{ width: "100%" }}
                placeholder="select one card"
                disabled={loadingCard}
                onChange={handleChange}
                filterOption={() => true}
                options={returnVisitList.map((el) => ({
                  value: el.card_id,
                  label: (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span>{el.card_name}</span>
                      <span style={{ color: "#888" }}>{el.card_code}</span>
                    </div>
                  ),
                  code: el.card_code,
                  name: el.card_name,
                }))}
                optionItemStyle={{ height: 40 }}
                optionItemClassName="custom-select-option"
              />
            </Form.Item>

            <Form.Item style={{ marginTop: "0px", textAlign: "left" }}>
              <Form.Item shouldUpdate>
                {() => {
                  const selected = form.getFieldValue("card_id");
                  return (
                    <Space size="middle">
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        disabled={!selected}
                      >
                        Return Card
                      </Button>
                    </Space>
                  );
                }}
              </Form.Item>
            </Form.Item>
          </Form>
        </Modal>
      </>
    );
  };

  // ADD VISITOR LIST
  const [addVisitorListOpen, setaddVisitorListOpen] = useState(false);
  const showModalAddVisitorList = () => {
    setaddVisitorListOpen(true);
  };

  const onAddVisitor = async (value, visitorId) => {
    setLoading(TruckFilled);

    try {
      await patchData(
        `/institution/update/list`,
        {
          action: "add",
          institution_id: detailData.id,
          name: value.name,
          nik: value.nik,
          phone: value.phone,
        },
        {},
        true
      );

      await getVisitor();
      form.resetFields();

      // productId = res.data.data.id;
      // console.log("BERHASIL MENAMBAHKAN KARTU");
      setLoading(false);
      setaddVisitorListOpen(false);
    } catch (error) {
      setLoading(false);
      setaddVisitorListOpen(false);

      console.log(error);
    }
  };
  const ModalAddVisitorList = () => {
    return (
      <>
        <Modal
          title="Add Visitor"
          open={addVisitorListOpen}
          //   onOk={showModalAddVisitor}
          onCancel={() => {
            setaddVisitorListOpen(false);
          }}
          // okButtonProps={{ disabled: true }}
          // cancelButtonProps={{ disabled: true }}
          footer={null}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={(value) => {
              onAddVisitor(value, detailData.id);
            }}
            autoComplete="off"
            style={{ textAlign: "left" }}
          >
            <Form.Item
              name={`name`}
              rules={
                [
                  //   {
                  //     required: true,
                  //   },
                ]
              }
              label={
                <div
                  style={{
                    fontWeight: "bold",
                    borderBottom: "2px solid #088395",
                    paddingBottom: "5px",
                    width: "fit-content",
                  }}
                >
                  Name
                </div>
              }
            >
              <Input
                allowClear
                size="large"
                placeholder={`Add Name`}
                prefix={<UserAddOutlined className="site-form-item-icon" />}
              />
            </Form.Item>

            <Form.Item
              name={`nik`}
              rules={
                [
                  //   {
                  //     required: true,
                  //   },
                ]
              }
              label={
                <div
                  style={{
                    fontWeight: "bold",
                    borderBottom: "2px solid #088395",
                    paddingBottom: "5px",
                    width: "fit-content",
                  }}
                >
                  NIK
                </div>
              }
            >
              <Input
                allowClear
                size="large"
                placeholder={`Add Nik`}
                prefix={<UserAddOutlined className="site-form-item-icon" />}
              />
            </Form.Item>

            <Form.Item
              name={`phone`}
              rules={[
                {
                  required: true,
                  message: "Phone number is required",
                },
                {
                  pattern: /^\d+$/,
                  message: "Phone number must be numeric",
                },
                {
                  min: 4,
                  message: "Phone number must be at least 4 digits",
                  validator: (_, value) => {
                    if (!value || value.length >= 4) return Promise.resolve();
                    return Promise.reject(
                      "Phone number must be at least 4 digits"
                    );
                  },
                },
              ]}
              label={
                <div
                  style={{
                    fontWeight: "bold",
                    borderBottom: "2px solid #088395",
                    paddingBottom: "5px",
                    width: "fit-content",
                  }}
                >
                  PHONE
                </div>
              }
            >
              <Input
                allowClear
                size="large"
                placeholder={`Add Phone Number`}
                prefix={<UserAddOutlined className="site-form-item-icon" />}
                maxLength={20}
              />
            </Form.Item>

            <Form.Item style={{ marginTop: "0px", textAlign: "left" }}>
              <Space size="middle">
                <Button type="primary" htmlType="submit" loading={loading}>
                  Add Visitor
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      </>
    );
  };

  //   MODAL EDIT VISITOR LIST
  const [editVisitorListOpen, seteditVisitorListOpen] = useState(false);

  const showModalEditVisitorList = () => {
    seteditVisitorListOpen(true);
  };
  const onEditVisitorList = async (value, visitorId) => {
    setLoading(true);

    try {
      await patchData(
        `/institution/update/list`,
        {
          institution_visitor_list_id: value.list_id,
          name: value.name,
          nik: value.nik,
          phone: value.phone,
          action: "update",
        },
        {},
        true
      );

      await getVisitor();
      form.resetFields();

      setLoading(false);
      seteditVisitorListOpen(false);
    } catch (error) {
      console.log(error);

      setLoading(false);
      seteditVisitorListOpen(false);
    }
  };
  const ModalEditVisitorList = () => {
    return (
      <>
        <Modal
          title="Edit Visitor"
          open={editVisitorListOpen}
          // onOk={showModalEditVisitor}
          onCancel={() => {
            seteditVisitorListOpen(false);
          }}
          footer={null}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={(value) => {
              onEditVisitorList(value, detailData.id);
            }}
            autoComplete="off"
            style={{ textAlign: "left" }}
          >
            <Form.Item name={`list_id`}></Form.Item>
            <Form.Item
              name={`name`}
              label={
                <div
                  style={{
                    fontWeight: "bold",
                    borderBottom: "2px solid #088395",
                    paddingBottom: "5px",
                    width: "fit-content",
                  }}
                >
                  Name
                </div>
              }
            >
              <Input
                allowClear
                size="large"
                placeholder={`Edit Name`}
                prefix={<UserAddOutlined className="site-form-item-icon" />}
              />
            </Form.Item>

            <Form.Item
              name={`nik`}
              rules={
                [
                  //   {
                  //     required: true,
                  //   },
                ]
              }
              label={
                <div
                  style={{
                    fontWeight: "bold",
                    borderBottom: "2px solid #088395",
                    paddingBottom: "5px",
                    width: "fit-content",
                  }}
                >
                  NIK
                </div>
              }
            >
              <Input
                allowClear
                size="large"
                placeholder={`Edit Nik`}
                prefix={<UserAddOutlined className="site-form-item-icon" />}
              />
            </Form.Item>

            <Form.Item
              name={`phone`}
              rules={[
                {
                  required: true,
                  message: "Phone number is required",
                },
                {
                  pattern: /^\d+$/,
                  message: "Phone number must be numeric",
                },
                {
                  min: 4,
                  message: "Phone number must be at least 4 digits",
                  validator: (_, value) => {
                    if (!value || value.length >= 4) return Promise.resolve();
                    return Promise.reject(
                      "Phone number must be at least 4 digits"
                    );
                  },
                },
              ]}
              label={
                <div
                  style={{
                    fontWeight: "bold",
                    borderBottom: "2px solid #088395",
                    paddingBottom: "5px",
                    width: "fit-content",
                  }}
                >
                  PHONE
                </div>
              }
            >
              <Input
                allowClear
                size="large"
                placeholder={`Add Phone Number`}
                prefix={<UserAddOutlined className="site-form-item-icon" />}
              />
            </Form.Item>

            <Form.Item style={{ marginTop: "0px", textAlign: "left" }}>
              <Space size="middle">
                <Button type="primary" htmlType="submit" loading={loadingCard}>
                  Edit Visitor
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      </>
    );
  };

  // LOADING COMPONENT
  const LoadingSkeleton = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center", // Memastikan elemen sejajar secara vertikal
          gap: "20px", // Jarak antara QR Code dan detail pengunjung
          padding: "20px", // Padding untuk memberikan ruang di sekitar konten
        }}
      >
        {/* Skeleton untuk QR Code */}
        <div>
          <Skeleton.Image
            active
            style={{
              width: 130, // Ukuran QR Code
              height: 130,
              borderRadius: "8px", // Rounded corner untuk tampilan modern
            }}
          />
        </div>

        {/* Skeleton untuk Detail Pengunjung */}
        <div
          style={{
            display: "flex",
            flexDirection: "column", // Menyusun detail pengunjung secara vertikal
            gap: "10px", // Jarak antar elemen detail pengunjung
          }}
        >
          {/* Nama Pengunjung */}
          <div>
            <Skeleton.Input
              active
              style={{
                width: "150px", // Lebar placeholder untuk label
                height: "16px",
                marginBottom: "5px", // Jarak antara label dan value
              }}
            />
            <Skeleton.Input
              active
              style={{
                width: "200px", // Lebar placeholder untuk value
                height: "20px",
              }}
            />
          </div>

          {/* Nomor Identitas */}
          <div>
            <Skeleton.Input
              active
              style={{
                width: "150px", // Lebar placeholder untuk label
                height: "16px",
                marginBottom: "5px", // Jarak antara label dan value
              }}
            />
            <Skeleton.Input
              active
              style={{
                width: "200px", // Lebar placeholder untuk value
                height: "20px",
              }}
            />
          </div>

          {/* Kode Pengunjung */}
          <div>
            <Skeleton.Input
              active
              style={{
                width: "150px", // Lebar placeholder untuk label
                height: "16px",
                marginBottom: "5px", // Jarak antara label dan value
              }}
            />
            <Skeleton.Input
              active
              style={{
                width: "200px", // Lebar placeholder untuk value
                height: "20px",
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  // const CardPicked = () => {
  //   return
  // };

  const data = [
    {
      key: "1",
      title: (
        <Space>
          <HomeOutlined style={{ color: "#088395" }} /> Institution
        </Space>
      ),
      value: detailData.institution || "-",
    },
    {
      key: "2",
      title: (
        <Space>
          <MergeCellsOutlined style={{ color: "#088395" }} /> Quota
        </Space>
      ),
      value: detailData.quota || "0",
    },

    {
      key: "3",
      title: (
        <Space>
          <ClockCircleOutlined style={{ color: "#088395" }} /> Visit Time
        </Space>
      ),
      value: (
        <>
          <Tag
            // Warna sesuai status is_take
            style={{
              fontWeight: "bold",
              padding: "5px 10px", // Padding untuk membuat Tag lebih besar dan mudah dibaca
            }}
          >
            <ClockCircleOutlined
              style={{
                color: "red",
                marginRight: 3,
              }}
            />{" "}
            UNLIMITED
          </Tag>
        </>
      ),
    },
    {
      key: "4",
      title: (
        <Space>
          <HomeFilled style={{ color: "#088395" }} /> Department
        </Space>
      ),
      value: detailData.department_name || "-",
    },
    {
      key: "5",
      title: (
        <Space>
          <HomeOutlined style={{ color: "#088395" }} /> Address
        </Space>
      ),
      value: detailData.address || "-",
    },
  ];

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: "40%",
    },
    {
      title: "Info",
      dataIndex: "value",
      key: "value",
      width: "60%",
    },
  ];

  return (
    <>
      <ModalAddVisitorList />
      <ModalEditVisitorList />
      <ModalAddCardVisitorList />
      <ModalResturnCardPerVisitorList />

      <Row justify="center">
        <Col xs={24} sm={22} md={18} lg={14}>
          <>
            <div
              style={{
                marginBottom: "30px",
                borderBottom: "2px solid #088395",
                padding: "10px 15px 0px",
                display: "flex",
                alignItems: "center", // Memastikan elemen sejajar secara vertikal
                justifyContent: "space-between", // Menyusun elemen di antara ruang kosong
              }}
            >
              {/* Breadcrumb */}

              {routeFrom === "detail-card" ? (
                <Breadcrumb style={{ margin: 0 }}>
                  <Breadcrumb.Item>
                    <a
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      Back
                    </a>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item style={{ fontWeight: "bold" }}>
                    Visitor Profile
                  </Breadcrumb.Item>
                </Breadcrumb>
              ) : (
                <Breadcrumb style={{ margin: 0 }}>
                  <Breadcrumb.Item>
                    <a
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      Dashboard
                    </a>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item style={{ fontWeight: "bold" }}>
                    Institution Profiles
                  </Breadcrumb.Item>
                </Breadcrumb>
              )}

              {/* Judul "PROFILE VISITOR" */}
              <div
                style={{
                  margin: 0, // Menghapus margin default dari Title
                  textAlign: "right", // Memastikan teks rata kanan
                  color: "#088395", // Warna teks sesuai tema
                  fontWeight: "bold", // Membuat teks lebih tebal
                }}
              >
                VISITOR PROFILE
              </div>
            </div>
            {loading ? (
              <LoadingSkeleton />
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center", // Memastikan elemen di dalam flex container sejajar secara vertikal
                    gap: "20px", // Menambahkan jarak antara QR Code dan detail pengunjung
                  }}
                >
                  {/* QR Code */}
                  <QRCode
                    id="myqrcode" // ID untuk referensi elemen QR Code
                    size={130}
                    errorLevel="H"
                    value={`${detailData.code}`} // Nilai yang akan di-encode ke dalam QR Code
                    style={{
                      border: "2px solid #2C74B3", // Border untuk QR Code
                      backgroundColor: "#fff", // Warna latar belakang QR Code
                      padding: "10px", // Padding untuk memberikan ruang di dalam border
                      borderRadius: "8px", // Rounded corner untuk tampilan lebih modern
                    }}
                    bgColor="#fff" // Background color untuk QR Code
                    type="canvas" // Pastikan tipe adalah "canvas"
                  />

                  {/* Detail Pengunjung */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column", // Menyusun detail pengunjung secara vertikal
                      gap: "10px", // Jarak antar elemen detail pengunjung
                    }}
                  >
                    {/* Nama Pengunjung */}
                    <div>
                      <div
                        style={{
                          fontWeight: "bold",
                          borderBottom: "2px solid #088395",
                          paddingBottom: "5px",
                          width: "fit-content",
                        }}
                      >
                        Institution Name
                      </div>
                      <p style={{ margin: "0", textAlign: "left" }}>
                        {detailData.name}
                      </p>
                    </div>

                    {/* Nomor Identitas */}
                    <div>
                      <div
                        style={{
                          fontWeight: "bold",
                          borderBottom: "2px solid #088395",
                          paddingBottom: "5px",
                          width: "fit-content",
                        }}
                      >
                        NIB
                      </div>
                      <p style={{ margin: "0", textAlign: "left" }}>
                        {detailData.id_number}
                      </p>
                    </div>

                    {/* Kode Pengunjung */}
                    <div>
                      <div
                        style={{
                          fontWeight: "bold",
                          borderBottom: "2px solid #088395",
                          paddingBottom: "5px",
                          width: "fit-content",
                        }}
                      >
                        Visitor Code
                      </div>
                      <p style={{ margin: "0", textAlign: "left" }}>
                        {detailData.code}
                      </p>
                    </div>
                  </div>
                </div>
                <Table
                  dataSource={data}
                  columns={columns}
                  pagination={false}
                  bordered
                  size="small"
                  style={{
                    border: "1px solid #088395",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                />

                {/* Bagian Tabel Visitor Lists */}
                <div
                  style={{
                    margin: "10px 0 10px 0",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <div
                    style={
                      {
                        // display: "flex",
                        // justifyContent: "space-between", // Jarak antar komponen
                        // alignItems: "center",
                      }
                    }
                  >
                    <h2 style={{ textAlign: "left" }}>List of Visitors</h2>
                    {detailData?.institution_visitor_list?.length >=
                    detailData.quota ? (
                      <></>
                    ) : (
                      <Popconfirm
                        placement="rightTop"
                        title={"Added New Visitor List"}
                        description={"Select additional actions"}
                        okText="Add Visitor List"
                        onConfirm={() => {
                          showModalAddVisitorList();
                        }}
                      >
                        <Button
                          style={{ marginLeft: "5px" }}
                          type="dashed"
                          icon={<UserAddOutlined />}
                        />
                      </Popconfirm>
                    )}
                  </div>

                  {detailData?.institution_visitor_list &&
                  detailData?.institution_visitor_list?.length > 0 ? (
                    <Table
                      dataSource={detailData.institution_visitor_list.map(
                        (item) => ({
                          key: item.id,
                          name: item.name,
                          nik: item.nik,
                          phone: item.phone,
                          regist_date: item.regist_date,
                          card_id: item.card_id,
                          card_code: item.card_code,
                          card_name: item.card_name,
                          is_taken_card: item.is_taken_card,
                          back_card_date: item.back_card_date,
                        })
                      )}
                      columns={[
                        {
                          title: "Name",
                          dataIndex: "name",
                          key: "name",
                          ellipsis: true,
                          width: 180,
                        },
                        {
                          title: "NIK",
                          dataIndex: "nik",
                          key: "nik",
                          ellipsis: true,
                          width: 150,
                        },
                        {
                          title: "Phone",
                          dataIndex: "phone",
                          key: "phone",
                          ellipsis: true,
                          width: 140,
                        },
                        {
                          title: "CTA",
                          key: "cta",
                          width: 110,
                          render: (item, record) => (
                            <>
                              {!item.phone || item.phone.trim() === "" ? (
                                "added phone number"
                              ) : (
                                <Button
                                  type="primary"
                                  icon={<WhatsAppOutlined />}
                                  title="Chat On Whatsapp"
                                  onClick={() => {
                                    if (
                                      !item.phone ||
                                      item.phone.trim() === ""
                                    ) {
                                      return null;
                                    }
                                    const cleaned = item.phone.replace(
                                      /\D/g,
                                      ""
                                    );
                                    if (cleaned && cleaned.startsWith("08")) {
                                      const formattedNumber =
                                        "62" + cleaned.slice(1);
                                      const whatsappUrl = `https://wa.me/${formattedNumber}`;
                                      window.open(
                                        whatsappUrl,
                                        "_blank",
                                        "noopener,noreferrer"
                                      );
                                    }
                                  }}
                                  style={{
                                    backgroundColor: "#25D366",
                                    borderColor: "#25D366",
                                    color: "white",
                                  }}
                                />
                              )}
                            </>
                          ),
                          fixed: false,
                        },
                        {
                          title: "Card",
                          key: "visitor_lists",
                          width: 120,
                          // fixed: "right",
                          render: (item, record) => (
                            <>
                              {item.card_code == null ? (
                                <Tag
                                  style={{
                                    fontWeight: "bold",
                                    padding: "5px 10px",
                                  }}
                                >
                                  - have no card -
                                </Tag>
                              ) : (
                                <Tag
                                  key={item.card_code}
                                  color={item.is_taken_card ? "green" : "red"}
                                  style={{
                                    fontWeight: "bold",
                                    padding: "5px 10px",
                                  }}
                                >
                                  {`${item.card_code}`}
                                </Tag>
                              )}
                            </>
                          ),
                        },
                        {
                          title: "Regist Date",
                          key: "regist_date",
                          width: 130,
                          // fixed: "right",
                          render: (item, record) => (
                            <>
                              {item.regist_date
                                ? formatDate(item.regist_date)
                                : "Harap Ambil Kartu"}
                            </>
                          ),
                        },
                        {
                          title: "Back Card Date",
                          key: "back_card_date",
                          width: 140,
                          // fixed: "right",
                          render: (item, record) => (
                            <>
                              {item.back_card_date
                                ? formatDate(item.back_card_date)
                                : "Belum dikembalikan"}
                            </>
                          ),
                        },
                        {
                          title: "Action",
                          key: "action",
                          fixed: "right",
                          width: 110,
                          render: (item, record) => (
                            <>
                              <Button
                                icon={<InfoCircleFilled />}
                                onClick={() => {
                                  seteditVisitorListOpen(true);
                                  form.setFieldsValue({
                                    list_id: item.key,
                                    name: item.name,
                                    nik: item.nik,
                                    phone: item.phone,
                                  });
                                }}
                              />
                              {item.is_taken_card ? (
                                <Button
                                  icon={<BackwardOutlined />}
                                  onClick={() => {
                                    setReturnCardVisitorListOpen(true);
                                    setreturnVisitList([item]);
                                  }}
                                />
                              ) : (
                                <Button
                                  icon={<CreditCardFilled />}
                                  onClick={() => {
                                    setaddCardVisitListOpen(true);
                                    form.setFieldsValue({
                                      list_id: item.key,
                                      name: item.name,
                                      nik: item.nik,
                                      phone: item.phone,
                                    });
                                  }}
                                />
                              )}
                            </>
                          ),
                        },
                      ]}
                      scroll={{ x: 1200 }}
                      pagination={false}
                      size="small"
                      style={{ width: "100%" }}
                    />
                  ) : (
                    <p style={{ textAlign: "center", fontStyle: "italic" }}>
                      No visitor lists available.
                    </p>
                  )}
                </div>
                {/* KARTU */}
                <>
                  {detailData.card_visitors?.length <= 0 ? (
                    detailData.expired_at === null ? (
                      <>
                        <div
                          style={{
                            fontWeight: "bold",
                            borderBottom: "2px solid #088395",
                            paddingBottom: "5px",
                            width: "fit-content",
                          }}
                        >
                          Pick Card
                        </div>
                        <p
                          style={{
                            color: "red",
                            fontSize: "12px",
                            // fontWeight: "normal",
                            animation: "blink 1s infinite",
                            textAlign: "left",
                            margin: "5px 0 10px 0",
                          }}
                        >
                          {
                            "Wait for Approval to be Able to Choose a Visitor Card"
                          }
                        </p>
                      </>
                    ) : (
                      <>
                        {/* <Form
                          form={form}
                          layout="vertical"
                          onFinish={(value) => {
                            onCardPicked(value, detailData.id);
                          }}
                          autoComplete="off"
                          style={{ textAlign: "left" }}
                        >
                          <Form.Item
                            name={`cardIds-${detailData.id}`}
                            rules={
                              [
                                //   {
                                //     required: true,
                                //   },
                                // ]
                            }
                            label={
                              <div
                                style={{
                                  fontWeight: "bold",
                                  borderBottom: "2px solid #088395",
                                  paddingBottom: "5px",
                                  width: "fit-content",
                                }}
                              >
                                Pick Card
                              </div>
                            }
                          >
                            <Select
                              mode="multiple"
                              style={{ width: "100%" }}
                              placeholder="select one visitor"
                              // disabled={loadingCard}
                              onChange={handleChange}
                              allowClear
                              onClear={() => {
                                getCardVisitor(
                                  null,
                                  detailData.visitor_type_name
                                );
                              }}
                              loading={loadingCard}
                              // onSearch={(value) => {
                              //   return debounceSearchCard({
                              //     search: value,
                              //     type: detailData.visitor_type_name,
                              //   });
                              // }}
                              filterOption={async (input, option) => {
                                // console.log(input);
                                // MENGALAMI DELAY
                                return await debounceSearchCard({
                                  search: input,
                                  type: detailData.visitor_type_name,
                                });
                                // var _a;
                                // return (
                                //   (_a =
                                //     option === null || option === void 0
                                //       ? void 0
                                //       : option.label) !== null && _a !== void 0
                                //     ? _a
                                //     : ""
                                // )
                                //   .toLowerCase()
                                //   .includes(input.toLowerCase());
                              }}
                              options={dataCardVisitor.map((el) => ({
                                label: el.name,
                                value: el.id,
                                emoji: el.code,
                                desc: el.type,
                              }))}
                              optionRender={(option) => (
                                <Space>
                                  <span
                                    role="img"
                                    aria-label={option.data.label}
                                  >
                                    {option.data.emoji}
                                  </span>
                                  {option.data.desc}
                                </Space>
                              )}
                            />
                          </Form.Item>

                          <Form.Item
                            style={{ marginTop: "0px", textAlign: "left" }}
                          >
                            <Space size="middle">
                              <Button
                                type="primary"
                                htmlType="submit"
                                loading={loadingCard}
                              >
                                Pick Card
                              </Button>
                            </Space>
                          </Form.Item>
                        </Form> */}
                      </>
                    )
                  ) : (
                    <>
                      <div>
                        <div
                          style={{
                            fontWeight: "bold",
                            borderBottom: "2px solid #088395",
                            paddingBottom: "5px",
                            width: "fit-content",
                          }}
                        >
                          Card Used History
                          {/* <Popconfirm
                            placement="rightTop"
                            title={"Additional Options"}
                            description={"Select additional actions"}
                            // cancelText="Return Card"
                            // onCancel={() => {
                            //   showModalCardBack();
                            //   // console.log("INI BACK");
                            // }}
                            okText="Return Card"
                            onConfirm={() => {
                              showModalCardBack();
                            }}
                            okButtonProps={
                              isDatePassed(detailData.expired_at) ||
                              detailData.active == "OUT"
                                ? { style: { display: "none" } }
                                : {}
                            }
                          >
                            <Button
                              style={{ marginLeft: "5px" }}
                              type="dashed"
                              icon={<InfoCircleTwoTone />}
                            />
                          </Popconfirm> */}
                        </div>

                        <Modal
                          title="Return Card"
                          open={cardBackOpen}
                          onOk={showModalCardBack}
                          onCancel={() => {
                            setcardBackOpen(false);
                          }}
                          // okButtonProps={{ disabled: true }}
                          // cancelButtonProps={{ disabled: true }}
                          footer={null}
                        >
                          <Form
                            form={form}
                            layout="vertical"
                            onFinish={(value) => {
                              // console.log("DISINI");
                              // console.log(detailData.id);
                              onCardReturn(value, detailData.id);
                              // onCardReturn(value, record.expandableData.id);
                            }}
                            autoComplete="off"
                            style={{ textAlign: "left" }}
                          >
                            <Form.Item
                              name={`return-cardIds-${detailData.id}`}
                              label={
                                <div
                                  style={{
                                    fontWeight: "bold",
                                    borderBottom: "2px solid #088395",
                                    paddingBottom: "5px",
                                    width: "fit-content",
                                  }}
                                >
                                  Pick Card
                                </div>
                              }
                            >
                              <Select
                                mode="multiple"
                                style={{ width: "100%" }}
                                placeholder="select one visitor"
                                // defaultValue={["china"]}

                                onChange={handleChange}
                                // searchValue={(val) => {
                                //   console.log(val);
                                // }}
                                options={detailData?.card_visitors
                                  ?.filter((card) => card.returned_at === null)
                                  .map((el) => ({
                                    label: el.card_name,
                                    value: el.card_id,
                                    emoji: el.card_code,
                                    desc: el.card_type,
                                  }))}
                                optionRender={(option) => (
                                  <Space>
                                    <span
                                      role="img"
                                      aria-label={option.data.label}
                                    >
                                      {option.data.emoji}
                                    </span>
                                    {option.data.desc}
                                  </Space>
                                )}
                              />
                            </Form.Item>

                            <Form.Item
                              style={{ marginTop: "0px", textAlign: "left" }}
                            >
                              <Space size="middle">
                                <Button
                                  type="primary"
                                  htmlType="submit"
                                  loading={loading}
                                  // onClick={() => {
                                  //   console.log("DISINI");
                                  //   console.log(detailData);

                                  //     onCardReturn()
                                  // }}
                                >
                                  Return Card
                                </Button>
                              </Space>
                            </Form.Item>
                          </Form>
                        </Modal>

                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap", // Memungkinkan elemen pindah ke baris baru jika tidak cukup ruang
                            gap: "10px", // Menambahkan jarak antara Tag
                            marginTop: "5px",
                          }}
                        >
                          {detailData.card_usage_history?.map((el) => (
                            <Tag
                              key={el.card_code} // Tambahkan key untuk setiap Tag agar lebih optimal
                              color={el.last_used ? "red" : "green"} // Warna sesuai status is_take
                              style={{
                                fontWeight: "bold",
                                padding: "5px 10px", // Padding untuk membuat Tag lebih besar dan mudah dibaca
                              }}
                            >
                              {`${el.card_code}`}
                              {el.last_used != null ? ` | ` : ""}
                              <i>
                                {el.last_used != null
                                  ? ` ${formatTimeDate(el.last_used)}`
                                  : ""}
                              </i>
                            </Tag>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                </>
              </>
            )}
          </>
        </Col>
      </Row>
    </>
  );
};
